import { hasDatePassed } from "../time/time";

export function shouldShowHoldingPage(overrideMessage) {
    if (!overrideMessage || !overrideMessage.start || !overrideMessage.end) {
        return false;
    }
    return hasDatePassed(overrideMessage.start) && !hasDatePassed(overrideMessage.end)
}